import { dig } from 'spiceutils';

/*
 * Get the countries for a given survey from a controlList.
 *
 * Returns an array of hashes with value of country.
 */
export default function getCountriesForSurvey(survey, controlList) {
  return dig(controlList, ['Country', 'Options', survey, { map: [(c) => ({ value: c })] }]);
}



// WEBPACK FOOTER //
// ./app/utils/AYDAUtils/getCountriesForSurvey.js